module.exports = __webpack_public_path__ + "static/media/appStoreEn.a111d976.svg";